import { useMediaQuery } from "usehooks-ts";
import { SlideTransition } from "../transition/SlideTransition";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";
import { FilterPopover } from "../filterPopover/FilterPopover";
import { DataButton, Icon, InputText } from "@sellar-io/components";
import { ReactNode } from "react";

export const TableHeader = ({
  bottomRightComponent,
  className,
  clickOutside,
  desktopFilterActive,
  setDesktopFilterActive,
  desktopWidth = 1200,
  filter,
  mobileFilter,
  mobileFilterActive,
  setMobileFilterActive,
  rightComponent,
  search,
  searchPlaceholder = "Search...",
  setSearch,
  tags,
}: {
  bottomRightComponent?: ReactNode;
  className?: string;
  clickOutside?: boolean;
  desktopFilterActive?: boolean;
  setDesktopFilterActive?: (active: boolean) => void;
  desktopWidth?: number;
  filter?: ReactNode;
  mobileFilter?: ReactNode;
  mobileFilterActive?: boolean;
  setMobileFilterActive?: (active: boolean) => void;
  rightComponent?: ReactNode;
  search: string;
  searchPlaceholder?: string;
  setSearch: (search: string) => void;
  tags?: ReactNode;
}) => {
  const isDesktop = useMediaQuery(`(min-width: ${desktopWidth}px)`);

  return (
    <>
      <div
        className={twMerge(
          "flex w-full border-collapse flex-wrap items-center justify-between bg-zinc-50",
          className,
          isDesktop
            ? "rounded-t-lg border border-b-0 border-zinc-300 p-4"
            : "border-b border-zinc-300 px-4 pb-4",
        )}
      >
        <div
          className={twMerge(
            "flex w-full items-center gap-2",
            !isDesktop && "flex-wrap pt-4",
          )}
        >
          <InputContainer
            className={twMerge(
              "w-[calc(100%-55px)] py-[0.4rem]",
              isDesktop ? "max-w-[300px]" : "",
            )}
          >
            <InputText
              required={false}
              placeholder={searchPlaceholder}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full"
            />
          </InputContainer>
          {filter &&
            (isDesktop ? (
              <FilterPopover
                icon="FILTER_VARIANT"
                buttonText="Filter"
                compact={false}
                active={desktopFilterActive || false}
                toggleActive={(value: boolean) =>
                  setDesktopFilterActive && setDesktopFilterActive(value)
                }
                clickOutside={clickOutside}
                portal
              >
                {filter}
              </FilterPopover>
            ) : (
              <DataButton
                onClick={() =>
                  setMobileFilterActive &&
                  setMobileFilterActive(!mobileFilterActive)
                }
                border={true}
                active={mobileFilterActive}
              >
                <Icon icon="FILTER_VARIANT" />
              </DataButton>
            ))}
          {!!rightComponent && (
            <div
              className={twMerge(
                "mr-2 flex items-center gap-1",
                isDesktop && "ml-auto",
              )}
            >
              {rightComponent}
            </div>
          )}
        </div>
        <div className="flex w-full flex-wrap items-center gap-2 md:flex-nowrap">
          <div className="flex w-full flex-wrap items-center">{tags}</div>
          {!!bottomRightComponent && (
            <div className="mt-2 w-full flex-none pr-2 md:w-[450px] md:text-right">
              {bottomRightComponent}
            </div>
          )}
        </div>
      </div>
      {!isDesktop && (filter || mobileFilter) && (
        <SlideTransition
          show={mobileFilterActive || false}
          className={"w-full"}
          parentClass="w-full"
        >
          {!!mobileFilter ? mobileFilter : filter}
        </SlideTransition>
      )}
    </>
  );
};
